import { proxy } from 'valtio';

var n=proxy({endpoint:"https://op-sign.crossbell.io/v1/",address:"0xbbc2918c9003d264c25ecae45b44a846702c0e7c"});var i=proxy({endpoint:"https://newbie.crossbell.io/v1/"});function f(){return i.endpoint}function c(o){i.endpoint=o;}function l(){return n?.endpoint??null}function u(){return n?.address??null}function x({endpoint:o,address:t}){n.endpoint=o,n.address=t;}

export { n as a, f as b, c, l as d, u as e, x as f };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-FTKA5YC2.mjs.map